// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// contexts
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
// components
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import MotionLazyContainer from './components/animate/MotionLazyContainer';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <MotionLazyContainer>
          <ThemeProvider>
            <ProgressBarStyle />
            <ScrollToTop />
            <Router />
          </ThemeProvider>
        </MotionLazyContainer>
      </CartProvider>
    </AuthProvider>
  );
}
